import type { FC } from "react";

import { Flex } from "components/core/Flex";
import { Text } from "components/core/Text";
import { Title } from "components/core/Title";
import ErrorIcon from "images/error-broccoli.svg?react";

const ErrorFallback: FC = () => (
  <Flex className="h-full">
    <Flex align="center" direction="col" flex={1} justify="center">
      <ErrorIcon />
      <Title className="mb-3.5" level={2} weight="semibold">
        {
          "We've encountered an issue. Please try refreshing the screen. If the problem persists, please contact our support team."
        }
      </Title>
      <Text as="p" className="mt-0 leading-5.5" variant="bodySmall">
        {
          "We're working to fix the issue. Please try again later or contact support if the problem persists."
        }
      </Text>
    </Flex>
  </Flex>
);

export default ErrorFallback;
